import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import {VueAxios} from './axios'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import Qs from 'qs'
import {Toast, Dialog} from 'vant'
import router from '../router'


// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
    timeout: 15000 // 请求超时时间
})

const err = (error) => {
    if (error.response) {
        const data = error.response.data
        const token = Vue.ls.get(ACCESS_TOKEN)
        // if (error.response.status === 403) {
        // }
        if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
            if (token) {
                store.dispatch('Logout').then(() => {
                    setTimeout(() => {
                        window.location.reload()
                    }, 1500)
                })
            }
        }
    }
    return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
    const token = Vue.ls.get(ACCESS_TOKEN)
    // Toast.allowMultiple();
    // Toast.loading({
    // });
    if (token) {
        config.headers['Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    }

    config.headers['mui'] = localStorage.getItem("mui")
    if (config.responseType) {
        service.responseType = config.responseType
        if (config.method === 'post') {
            config.data = Qs.stringify({...config.data})
        } else {
            config.params = {...config.params}
        }
    } else {
        config.headers['Accept'] = 'application/json'
        if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
            if (config.method === 'post') {
                config.data = Qs.stringify({...config.data})
            } else {
                config.params = {...config.params}
            }
        }
    }
    return config
}, err)

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}

// response interceptor
service.interceptors.response.use((response) => {
    // Toast.clear()
    if (typeof response.data == "string") {
        try {
            response.data = JSON.parse(response.data.replace(/'/g, "\""));
            // eslint-disable-next-line no-empty
        } catch (e) {
        }
    }
    if (response.data.code === '0000') {
        return response.data
    } else if (response.data.code === '8888') {
        var that = this;
        Dialog.confirm({
            message: '您还没有登录，是否需要跳转登录？',
        })
            .then(() => {
                // router.replace({
                //     path: '/checkLogin',
                //     // query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
                // })
                // that.$router.push({name: 'checkLogin', query: {urls:  encodeURI(window.location.href)}});
                if (getQueryVariable('mui')) {
                    localStorage.setItem("mui", getQueryVariable('mui'))
                }
                console.log("----"+"/checkLogin?mui=" + getQueryVariable('mui') +
                    "&urls=" + encodeURIComponent(window.location.href))
                window.location.href = "/checkLogin?mui=" + getQueryVariable('mui') +
                    "&urls=" + encodeURIComponent(window.location.href);

                // on confirm
                // window.location.href = "/getLoginUrl?urls=" + encodeURI(window.location.href);
            })
            .catch(() => {
                // on cancel
            });
        return Promise.reject(response.data.content)
    } else {
        if (service.responseType) {
            const data = response.data
            if (typeof (data) === 'object' &&
                Object.prototype.toString.call(data).toLowerCase() === '[object object]' && !data.length) {
                Toast(response.data.content)
                return Promise.reject(response.data.content)
            } else {
                // if (typeof data === 'dd') {
                //   antDesign.Message.error(response.data.content)
                //   return Promise.reject(response.data.content)
                // }
                // 有可能下载失败，返回{code: '500'},但responseType: 'blob'会把data强制转为blob，导致下载undefined.excel
                // 解决：将已转为blob类型的data转回json格式，判断是否下载成功
                const r = new FileReader()
                r.onload = function () {
                    // 如果JSON.parse(this.result)不报错，说明this.result是json字符串，是下载报错情况的返回值，弹框提示
                    // 如果JSON.parse(this.result)报错，说明下载成功，进入catch
                    try {
                        const resData = JSON.parse(this.result) // this.result为FileReader获取blob数据转换为json后的数据，即后台返回的原始数据
                        if (resData && resData.code && resData.code === '500') {
                            alert('下载失败')
                        }
                    } catch (err) {
                        let fileName = response.headers['content-disposition']
                        // 获取文件名
                        if (fileName && fileName.length >= 2) {
                            fileName = fileName.split('=')[1]
                        }
                        fileName = decodeURIComponent(fileName)
                        // 兼容ie11
                        if (window.navigator.msSaveOrOpenBlob) {
                            try {
                                const blobObject = new Blob([data])
                                window.navigator.msSaveOrOpenBlob(blobObject, fileName)
                            } catch (e) {
                                console.log(e)
                            }
                            return
                        }
                        const url = window.URL.createObjectURL(new Blob([data]))
                        const link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', fileName)
                        document.body.appendChild(link)
                        link.click()
                        // eslint-disable-next-line no-undef
                    }
                }
                r.readAsText(data) // FileReader的API
            }
        } else {
            if (response.data.content !== undefined && response.data.content !== '') {
                Toast(response.data.content)
            }
            return Promise.reject(response.data.content)
        }
    }
}, error => {
    //String(error).toLowerCase().indexOf('timeout')
    if (error && error.stack.indexOf('timeout') > -1) {
        Toast('请求超时')
    } else {
        Toast('网络错误')
    }
    // let config = error.config;
    // if (!config || !config.retry) return Promise.reject(err);
    // config.__retryCount = config.__retryCount || 0;

    // // Check if we've maxed out the total number of retries
    // if (config.__retryCount >= config.retry) {
    //   // Reject with the error
    //   return Promise.reject(err);
    // }

    // // Increase the retry count
    // config.__retryCount += 1;

    // // Create new promise to handle exponential backoff
    // var backoff = new Promise(function (resolve) {
    //   setTimeout(function () {
    //     resolve();
    //   }, config.retryDelay || 1);
    // });

    // // Return the promise in which recalls axios to retry the request
    // return backoff.then(function () {
    //   return axios(config);
    // });
})

const installer = {
    vm: {},
    install(Vue) {
        Vue.use(VueAxios, service)
    }
}

export {
    installer as VueAxios,
    service as axios
}
